"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const _tagged_template_literal = require("@swc/helpers/_/_tagged_template_literal");
function _templateObject() {
    const data = _tagged_template_literal._([
        "\n  ",
        "\n\n  fragment ProductListingCarouselItem on EditorialPage {\n    ...EditorialPage\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal._([
        "\n  ",
        "\n\n  fragment ProductListingCarousel on EditorialCarousel {\n    editorials {\n      ...ProductListingCarouselItem\n    }\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.productListingCarousel = void 0;
var _fetching = require("@ori/fetching");
var _editorialPageFragment = require("./editorialPageFragment");
const productListingCarouselItem = (0, _fetching.gql)(_templateObject(), _editorialPageFragment.editorialPageFragment);
const productListingCarousel = exports.productListingCarousel = (0, _fetching.gql)(_templateObject1(), productListingCarouselItem);
